import Vue from 'vue';
import VueRouter from 'vue-router';
import Signup from '../views/Signup.vue';
import Finish from '../views/Finish.vue';
import ShowContract from '../views/ShowContract.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/finish',
        component: Finish,
        name: 'finish',
    },
    {
        path: '/:step?',
        props: true,
        name: 'signup',
        component: Signup,
        children: [
            {
                path: 'contract/:contract_urlsafe',
                alias: 'contracts/:contract_urlsafe',
                props: true,
                name: 'showcontract',
                component: ShowContract,
            },
            {
                path: 'offers/:comma_seperated_offer_urlsafes',
                alias: 'offer/:comma_seperated_offer_urlsafes',
                props: true,
                name: 'showoffer',
                component: ShowContract,
            },
            {
                path: '',
                name: 'default',
                component: ShowContract,
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
